import {
  getAuditsCountSelector,
  getConsolidationsCount as getConsolidationsCountSelector,
  getContainersCountSelector,
  getPartnersCountSelector,
  getRouteCount,
  getTripCount,
  getUsersNumber,
} from '@returnmates/client-core/src/selectors/admin'
import { getLocationsCount } from '@returnmates/client-core/src/selectors/location'
import { getManifestsNumber } from '@returnmates/client-core/src/selectors/manifest'
import { getOperationsCountSelector } from '@returnmates/client-core/src/selectors/operation'
import { getPackagesCount } from '@returnmates/client-core/src/selectors/packages'
import { getServicedZipCodesCountSelector } from '@returnmates/client-core/src/selectors/zipCode'
import clsx from 'clsx'
import { memo, useCallback, useContext, useMemo } from 'react'
import { useSelector } from 'react-redux'
import { useLocation, useNavigate } from 'react-router-dom'

import {
  AUDITS,
  CONSOLIDATIONS,
  CONTAINERS,
  LOCATIONS,
  MANIFEST,
  OPERATIONS,
  PACKAGE_LOG,
  PARTNERS,
  ROUTES,
  SAVERS,
  TRIPS_LOG,
  USERS,
  ZIP_CODES,
} from '../../../constants/paths'
import { FlyoutSidebarContext } from '../../../pages/Main'
import useStyles from '../styles'
import { PageInfo } from '../types'

interface Props {
  tab: PageInfo
}

function Tab({ tab }: Props) {
  const location = useLocation()
  const navigate = useNavigate()
  const tripsCount = useSelector(getTripCount)
  const routesCount = useSelector(getRouteCount)
  const packagesCount = useSelector(getPackagesCount)
  const usersCount = useSelector(getUsersNumber)
  const locationsCount = useSelector(getLocationsCount)
  const auditsCount = useSelector(getAuditsCountSelector)
  const partnersCount = useSelector(getPartnersCountSelector)
  const servicedZipCodesCount = useSelector(getServicedZipCodesCountSelector)
  const manifestsCount = useSelector(getManifestsNumber)
  const operationsCount = useSelector(getOperationsCountSelector)
  const consolidationsCount = useSelector(getConsolidationsCountSelector)
  const containersCount = useSelector(getContainersCountSelector)
  const { handleCloseSidebar } = useContext(FlyoutSidebarContext)

  const pathname = useMemo(() => '/'.concat(location.pathname.split('/')[1]), [location.pathname])

  const isActive = useMemo(() => pathname === tab.link, [pathname, tab.link])

  const classes = useStyles({})

  const tabCount = useMemo(() => {
    switch (tab.link) {
      case TRIPS_LOG:
        return tripsCount
      case ROUTES:
        return routesCount
      case PACKAGE_LOG:
        return packagesCount
      case USERS:
        return usersCount
      case LOCATIONS:
        return locationsCount
      case AUDITS:
        return auditsCount
      case SAVERS:
        return auditsCount
      case PARTNERS:
        return partnersCount
      case ZIP_CODES:
        return servicedZipCodesCount
      case MANIFEST:
        return manifestsCount
      case OPERATIONS:
        return operationsCount
      case CONSOLIDATIONS:
        return consolidationsCount
      case CONTAINERS:
        return containersCount
    }
  }, [
    tab.link,
    tripsCount,
    routesCount,
    packagesCount,
    usersCount,
    locationsCount,
    auditsCount,
    partnersCount,
    servicedZipCodesCount,
    manifestsCount,
    operationsCount,
    consolidationsCount,
    containersCount,
  ])

  const handleClick = useCallback(() => {
    if (tab.link !== pathname) {
      navigate(tab.link)

      handleCloseSidebar()
    }
  }, [tab.link, pathname, navigate, handleCloseSidebar])

  return (
    <div onClick={handleClick} className={clsx(classes.tab, { [classes.activeTab]: isActive })}>
      {tab.tabIcon}
      <p className={classes.tabTitle}>{tab.tabTitle}</p>
      {typeof tabCount === 'number' ? <p className={classes.tabDataCount}>{tabCount}</p> : null}
    </div>
  )
}

export default memo(Tab)
